import SidebarCategories from './SidebarCategories';

export default SidebarCategories;
